export class LicenseType {
  licenseTypeId: string;
  code: string;
  name: string;
  deleted: number;

  constructor(params: Params) {
    this.licenseTypeId = params?.licenseTypeId;
    this.code = params?.code;
    this.name = params?.name;
    this.deleted = params?.deleted;
  }

}

interface Params {
  licenseTypeId: string;
  code: string;
  name: string;
  deleted: number;
}

export enum licenseTypeCode {
  PERP = "PERP",
  TIME = "TIME",
  UNIT = "UNIT",
}